import { useContext, useState } from 'react';

import { Box, Text } from '@zillow/constellation-10';

import { useMultiplexDetails } from '../../../../hooks/queries/multiplex';
import useIsOnReviewStep from '../../../../hooks/useIsOnReviewStep';
import { useSelector } from '../../../../selectors/useSelector';

import { DISPLAY_SERVER_ERROR_AT } from '../../../../constants/WizardConstants';

import PhotoGallery from '../../../../components/PhotoGallery';
import PhotoUpload from '../../../../components/PhotoUpload';
import WizardAlert from '../../../../components/WizardAlert';
import { ModularListingContext } from '../../../../containers/CreateListingPage/context';

const PhotoUploadFormField = () => {
  const isOnReviewStep = useIsOnReviewStep();
  const { data } = useMultiplexDetails({ enabled: !isOnReviewStep });

  const {
    modularListingState: { serverErrorObj },
  } = useContext(ModularListingContext);

  const {
    properties: {
      currentProperty: { isFeed, photos: reduxPhotos },
    },
  } = useSelector((state) => state);

  const photos = data?.propertyPhotos ? data.propertyPhotos : reduxPhotos;

  const [uploadingCount, setUploadingCount] = useState(0);

  if (!photos?.length && isFeed) {
    return (
      <Box css={{ width: '100%' }} data-testid="PhotoUploadFormField">
        <Text css={{ marginTop: '200', flex: '1 0 fit-content' }}>No photos available</Text>
      </Box>
    );
  }

  return (
    <Box css={{ width: '100%' }} data-testid="PhotoUploadFormField">
      <WizardAlert serverErrorObj={serverErrorObj} displayAt={DISPLAY_SERVER_ERROR_AT.FIELD} />

      {photos.length > 0 || uploadingCount > 0 ? (
        <PhotoGallery uploadingCount={uploadingCount} setUploadingCount={setUploadingCount} />
      ) : (
        <>{!isFeed && <PhotoUpload setUploadingCount={setUploadingCount} uploadingCount={uploadingCount} />}</>
      )}
    </Box>
  );
};

export default PhotoUploadFormField;
